class ScaController {
  /* @ngInject */

  constructor($scope, $rootScope, ScaService, scaTypeConstants, $filter) {
    let deregScaStatus;
      this.busy = false;

      this.sendScaNotification = () => {
        ScaService.stopPoller(this.scaType);
        ScaService.startPoller(this.scaType);

        this.busy = true;

        deregScaStatus = $rootScope.$on('POLLER_SCA_COMPLETED_TYPE_' + this.scaType, () => {
         this.closeModal()
        });
        deregScaStatus = $rootScope.$on("POLLER_SCA_ERROR_TYPE_" + this.scaType, () => {
          this.closeModal()
        });
      };

      this.closeModal = () => {
        if (this.onScaCompleted) this.onScaCompleted()
        this.busy = false;
      }

      this.$onInit = () => {
        switch(this.scaType) {
          case scaTypeConstants.DOCUMENTS:
            this.description = $filter('translate')("sca.description.documents");;
            break;
          case scaTypeConstants.MOVEMENTS:
            this.description = $filter('translate')("sca.description.movements");
            break;
           case scaTypeConstants.LOGIN:
            this.description = $filter('translate')("sca.description.login");
            break;
          default:
              this.description = "";
            break;
        }
      }

      $scope.$on("$destroy", () => {
        if (deregScaStatus) deregScaStatus();
      });
  }
}

export default ScaController;



/** WEBPACK FOOTER **
 ** ./client/app/components/sca/sca.controller.js
 **/